// Cart.vue

<template>
  <div>
    <b-card
        no-body>
      <div slot="header">
        <span>Payment</span>
      </div>
      <b-list-group flush>
        <b-list-group-item>
          <label for="po">PO (optional)</label>
          <b-form-input name="po" v-model="ponumber" :state="validPO"></b-form-input>
          <span v-if="validPO === false" class="text-danger">Max length 50 characters.</span>
        </b-list-group-item>
        <b-list-group-item>
          <label for="cc">Last 4 for CC on file (optional)</label>
          <b-form-input name="cc" v-model="lastfour" :state="validCC"></b-form-input>
          <span v-if="validCC === false" class="text-danger">Max 4 numbers</span>
        </b-list-group-item>

      </b-list-group>
    </b-card>
    <div>&nbsp;</div>

    <b-card
        no-body>
      <div slot="header">
        <span class="text-muted">Your Cart</span>
        <button v-if="items.length > 0" type="button" class="badge btn btn-sm btn-light float-right" @click="clearCart()"><i class="fa fa-trash"></i></button>
        <span class="badge badge-secondary badge-pill float-right"> {{ items.length }}</span>
      </div>
      <b-list-group flush>

        <b-list-group-item v-for="(item, index) in items" :key="index">
          <Item :item="item" :index="index" :productdata="productdata"/>
        </b-list-group-item>

        <b-list-group-item>
          <span>Total ({{ $parent.productdata.currencyText }})</span>
          <strong class="float-right">{{ $parent.productdata.currency }}{{ total.toLocaleString() }}</strong>
          <br/><small class="text-danger">Shipping costs not included.</small>
        </b-list-group-item>
        <b-list-group-item>
          <b-button class="btn-secondary btn-block" @click="addItem()">Configure New Smartop</b-button>
          <b-button class="btn-danger btn-block" @click="submitOrder()">Submit Smartop Order</b-button>

        </b-list-group-item>

      </b-list-group>
    </b-card>

    <div>
      <b-modal ref="smartop-modal-submit" id="smartop-modal-submit" :title="confirmationTitle" no-stacking no-close-on-backdrop no-close-on-esc>
        <div>{{ confirmationBody }}</div>
        <div v-if="confirmationBody === ''" style="text-align: center;"><i class="fa fa-spinner fa-spin fa-3x"></i></div>
        <div slot="modal-footer">
          <b-button @click="$bvModal.hide('smartop-modal-submit')" v-if="confirmationBody.length">OK</b-button>
        </div>
      </b-modal>

      <b-modal ref="smartop-modal-error" id="smartop-modal-error" title="Whoops!" no-stacking no-close-on-backdrop>
        <div>
          It looks like you may be missing some information on your order or you have an incomplete item in your cart.
          <br/><br/>Note that all required fields are displayed with an asterisk. Please verify that you have complete
          billing and shipping information and at least one completely configured Smartop on your order form.
        </div>

        <div slot="modal-footer">
          <b-button @click="$bvModal.hide('smartop-modal-error')">Try Again</b-button>
        </div>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Item from './Item.vue'

const https = require('https');

export default {
  components: {
    Item
  },
  computed: {
    total() {
      return this.items.filter((item) => item.totalPrice).reduce((total, item) => total + Number(item.totalPrice), 0);
    },
    validPO() {

      if (this.ponumber.length === 0) {
        return null;
      }

      return this.ponumber.length < 50;
    },
    validCC() {

      if (this.lastfour.length === 0) {
        return null;
      }

      return this.lastfour.length <= 4 && /^\d+$/.test(this.lastfour);
    }
  },
  methods: {
    addItem() {
      var newItem = {
        price: 0,
        totalPrice: 0,
        isNew: true,
        productList: this.productdata.products,
        options: [],
        source: 'default'
      }
      if (this.$parent.$data.urlSource == 'bullfrog') {
        newItem.source = 'bullfrog',
        newItem.spaBrand = 'Bullfrog Swim Spa';
        newItem.measurementA = '';
        newItem.measurementB = 94;
        newItem.hingeLength = 94;
        newItem.cornerRadius = '';
        newItem.acrylicHeight = 6.5;
        newItem.options[1] = 0;
      }
      //pass this into our local array
      this.items.push(newItem);
    },
    addDuplicate(index){
      if(confirm('Do you want to duplicate the item?')) {
        var newItem = Object.assign({}, this.items[index]);
        newItem.productList = this.productdata.products;
        newItem.options = [];
        newItem.options[0] = this.items[index].options[0];
        newItem.options[1] = this.items[index].options[1];
        newItem.options[2] = this.items[index].options[2];
        this.items.push(newItem);
        this.persist();
      }
    },
    removeItem(index) {
      this.items.splice(index, 1);
      this.persist();
    },
    clearCart() {
      if (confirm("Do you want to clear your cart?")) {
        this.items = [];
        this.persist();
      }
    },
    clearCartOnCountryChange() {
      this.items = [];
      this.persist();
    },
    validateSubmit() {
      this.$parent.$data.highlightMissingFields = true;

      if (this.validPO === false) {
        return false;
      }

      if (this.validCC === false) {
        return false;
      }

      if (!this.$parent.shipAddress.company) {
        return false;
      }
      if (!this.$parent.shipAddress.fname) {
        return false;
      }
      if (!this.$parent.shipAddress.lname) {
        return false;
      }
      if (!this.$parent.shipAddress.address) {
        return false;
      }
      if (!this.$parent.shipAddress.city) {
        return false;
      }
      if (!this.$parent.shipAddress.country) {
        return false;
      }

      if (this.$parent.shipAddress.country === 'US' || this.$parent.shipAddress.country === 'CA') {
        if (!this.$parent.shipAddress.state) {
          return false;
        }
      }

      if (!this.$parent.shipAddress.zip) {
        return false;
      }
      if (!this.$parent.shipAddress.phone) {
        return false;
      }

      if (!this.$parent.$refs.shipTo.validEmail) {
        return false;
      }

      if (!this.$parent.billAddress.company) {
        return false;
      }
      if (!this.$parent.billAddress.fname) {
        return false;
      }
      if (!this.$parent.billAddress.lname) {
        return false;
      }
      if (!this.$parent.billAddress.address) {
        return false;
      }
      if (!this.$parent.billAddress.city) {
        return false;
      }
      if (!this.$parent.billAddress.country) {
        return false;
      }

      if (this.$parent.billAddress.country === 'US' || this.$parent.billAddress.country === 'UK') {
        if (!this.$parent.billAddress.state) {
          return false;
        }
      }

      if (!this.$parent.billAddress.zip) {
        return false;
      }
      if (!this.$parent.billAddress.phone) {
        return false;
      }

      if (!this.$parent.$refs.billTo.validEmail) {
        return false;
      }

      this.$parent.$data.highlightMissingFields = null;

      if (!this.items.length > 0) {
        return false;
      }

      //verify each item
      for (var key in this.items) {

        //‘You have an incomplete item in your cart’
        // make sure each element of an item has a valid, none are optional (except for comments)
        if (!(this.items[key].isComplete)) {
          return false;
        }
      }

      return true;
    },
    submitOrder() {
      if (this.isSubmitting) {
        return;
      }

      if (!this.validateSubmit()) {
        this.$refs['smartop-modal-error'].show();
        return;
      }

      this.isSubmitting = true;

      this.confirmationTitle = 'Processing...';
      this.confirmationBody = '';

      this.$refs['smartop-modal-submit'].show();

      /*
          This method takes the items that have been selected and converts it to a submittable object / array. The reason
          for this conversion is that the original stored list in this.items stores the selected indexes from combo boxes
          for things like options and styles, instead of their actual name. The web service that receives this info needs
          to know the name of the item or option that was selected.
      */

      if (this.$parent.country == 'UK') {
        this.$parent.shipAddress.state = 'UK';
        this.$parent.billAddress.state = 'UK';
      }

      //copy to a temporary order object, which we will submit
      this.order = {};
      this.order.ponumber = this.ponumber;
      this.order.lastfour = this.lastfour;
      this.order.shipAddress = this.$parent.shipAddress;
      this.order.billAddress = this.$parent.billAddress;

      //copy items into temp array, this must detach from Vue's getters and setters
      this.order.items = JSON.parse(JSON.stringify(this.items));

      for (var key in this.order.items) {
        if (!this.order.items.hasOwnProperty(key)) {
          continue;
        }

        let productList = this.order.items[key].productList;

        delete this.order.items[key].productList;

        this.order.items[key].decoShield = productList[this.items[key].style].decos[this.items[key].decoShield].name;
        this.order.items[key].decoTrim = productList[this.items[key].style].decos[this.items[key].decoShield].trims[this.items[key].decoTrim];
        this.order.items[key].style = productList[this.items[key].style].name;
        this.order.items[key].sku = productList[this.items[key].style].decos[this.items[key].decoShield].sku;

        for (var key2 in this.order.items[key].options) {
          if (!this.order.items[key].options.hasOwnProperty(key2)) {
            continue;
          }

          //set the option as an object, instead of an index
          this.order.items[key].options[key2] = {};
          //set it's name
          this.order.items[key].options[key2].name = productList[this.items[key].style].options[key2].name;
          this.order.items[key].options[key2].value = productList[this.items[key].style].options[key2].values[this.items[key].options[key2]].name;
          this.order.items[key].options[key2].id = productList[this.items[key].style].options[key2].values[this.items[key].options[key2]].id;
          this.order.items[key].options[key2].price = productList[this.items[key].style].options[key2].values[this.items[key].options[key2]].price;
          this.order.items[key].options[key2].dropdown_label = productList[this.items[key].style].options[key2].values[this.items[key].options[key2]].dropdown_label;
        }

      }
      this.order.total = this.total;

      let headers = {
        'Content-Type': 'application/json',
        'token': process.env.VUE_APP_API_TOKEN
      };

      let url = process.env.VUE_APP_API + '/api/smartop-dealer/save-order';

      // dump SSL verificaiton
      // At request level
      const instance = this.axios.create({
        httpsAgent: new https.Agent({
          rejectUnauthorized: false
        })
      });

      //submit the order to Levi's endpoint
      let currentObj = this;
      instance.post(url, {
        data: this.order
      }, {headers: headers})
          .then(function (response) {
            currentObj.output = response.data;

            currentObj.confirmationTitle = 'Thank You! – Order Submitted';
            currentObj.confirmationBody = 'Your order has been submitted. ' +
                'You will receive an email detailing your order for confirmation within 24 hours of submission.';

            currentObj.$refs['smartop-modal-submit'].show();

            //clear out data
            currentObj.selectedItem = '';
            currentObj.items = [];
            currentObj.ponumber = '';
            currentObj.lastfour = '';

            currentObj.persist();
            currentObj.isSubmitting = false;
          })
          .catch(function (error) {
            if (error.response && error.response.status === 409 && error.response.data.reason === 'price_mismatch') {
              currentObj.$parent.refreshPricing().then(function () {
                var jacuzziModels = ['425', '435', '445', '475', '485', '495'];
                for (var i = 0; i < currentObj.items.length; i++) {
                  var item = currentObj.items[i];
                  item.productList = currentObj.productdata.products;
                  if (item.spaBrand === 'Jacuzzi' && item.spaYear >= 2020) {
                    for (var j = 0; j < jacuzziModels.length; j++) {
                      if (item.spaModel && item.spaModel.indexOf(jacuzziModels[j]) > -1) {
                        item.productList = currentObj.productdata.jacuzzi400products;
                        break;
                      }
                    }
                  }
                }
              });
              
              currentObj.confirmationTitle = 'Pricing Updated';
              currentObj.confirmationBody = 'Our pricing has been updated. Please review the updated prices and submit again.';
              currentObj.$refs['smartop-modal-submit'].show();
              currentObj.isSubmitting = false;
              return;
            }

            currentObj.output = error;
            currentObj.$refs['smartop-modal-error'].show();
            currentObj.isSubmitting = false;
          })
      ;
    },
    persist() {
      localStorage.country = this.$parent.country;
      localStorage.shipAddress = JSON.stringify(this.$parent.shipAddress);
      localStorage.billAddress = JSON.stringify(this.$parent.billAddress);
      localStorage.items = JSON.stringify(this.items);
      localStorage.ponumber = this.ponumber;
      localStorage.lastfour = this.lastfour;
    }
  },
  mounted() {
    if (localStorage.country) {
      //reset country selection
      this.$parent.selectCountry(localStorage.country);
    }
    if (localStorage.billAddress) {
      this.$parent.billAddress = JSON.parse(localStorage.billAddress);
    }
    if (localStorage.shipAddress) {
      this.$parent.shipAddress = JSON.parse(localStorage.shipAddress);
    }
    if (localStorage.items) {
      this.items = JSON.parse(localStorage.items);
    }
    if (localStorage.ponumber) {
      this.ponumber = localStorage.ponumber;
    }
    if (localStorage.lastfour) {
      this.lastfour = localStorage.lastfour;
    }
  },
  data() {
    return {
      isSubmitting: false,
      order: {},
      productdata: this.$parent.productdata,
      items: [],
      ponumber: '',
      lastfour: '',
      selectedItem: {options: []},
      confirmationTitle: '',
      confirmationBody: '',
    }
  }
}
</script>

